module.exports = __webpack_public_path__ + "static/media/users.4b1c087f.csv";